@import '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.empty-state-container {
  align-items: center;
  justify-content: flex-start;
  min-height: 60vh;
  padding: @space-48;
  padding-top: @space-24;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.empty-state-icon {
  width: 120px;
  height: 120px;
  margin-bottom: @space-48;
  opacity: 0.6;
}

.empty-state-content {
  margin-bottom: @space-48;
}

.empty-state-header {
  margin-bottom: @space-24;
  color: var(--grey-700);
}

.empty-state-description {
  margin-bottom: @space-24;
  color: var(--grey-600);
  line-height: 1.5;
}

.empty-state-sub-description {
  color: var(--grey-500);
  line-height: 1.4;
}

.promotional-banner-container {
  width: 100%;
  max-width: 800px;
  margin-top: @space-32;
}

@media @mobile {
  .empty-state-container {
    padding: @space-32;
    min-height: 50vh;
  }

  .empty-state-icon {
    width: 80px;
    height: 80px;
    margin-bottom: @space-32;
  }
}
